document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function clearHeaders() {
    const headers = document.querySelectorAll('.mz-suggest-item-header');
    headers.forEach((header) => header.remove());
  }
  function injectHeaderBeforeSuggestItem(itemText, headerText) {
    const suggestItems = document.querySelectorAll('.mz-suggest-item');
    for (const item of suggestItems) {
      if (item.textContent.trim() === itemText) {
        const headerDiv = document.createElement('div');
        headerDiv.title = headerText;
        headerDiv.textContent = headerText;
        headerDiv.classList.add('mz-suggest-item-header');
        item.parentNode.insertBefore(headerDiv, item);
        break;
      }
    }
  }
  function afterAutocomplete() {
    setTimeout(() => {
      clearHeaders();
      injectHeaderBeforeSuggestItem('women', 'Gender');
      injectHeaderBeforeSuggestItem('summer', 'Seasons');
    }, 0);
  }
  function afterUpdate() {
    // placeholder
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate);
  }
  if (mz.suggest && mz.suggest.$bus) {
    mz.suggest.$bus.on('after-autocomplete', afterAutocomplete);
    mz.suggest.$bus.on('toggle-autocomplete-open', afterAutocomplete);
  }
});
